var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 472 472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B33",
    d: "M235.7 136.4a2.5 2.5 0 0 1-2.5-2.5V68.7a2.5 2.5 0 0 1 5 0v65.2a2.5 2.5 0 0 1-2.5 2.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACDBE6",
    d: "M235.7 68.7a18.8 18.8 0 1 0 0-37.6 18.8 18.8 0 0 0 0 37.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B33",
    d: "M277.2 136.4a2.5 2.5 0 0 1-2.3-1.6l-.2-.9v-48a2.5 2.5 0 0 1 2.5-2.4h45V40.1a2.5 2.5 0 1 1 5 0V86a2.5 2.5 0 0 1-2.4 2.5h-45.1v45.4a2.5 2.5 0 0 1-2.5 2.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACDBE6",
    d: "M324.8 40.1a18.8 18.8 0 1 0 0-37.6 18.8 18.8 0 0 0 0 37.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B33",
    d: "M194.2 136.4a2.5 2.5 0 0 1-2.5-2.5V88.5h-45A2.5 2.5 0 0 1 144 86V40a2.5 2.5 0 1 1 5 0v43.4h45a2.5 2.5 0 0 1 2.6 2.5v47.9a2.5 2.5 0 0 1-2.5 2.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACDBE6",
    d: "M146.6 40.1a18.8 18.8 0 1 0 0-37.6 18.8 18.8 0 0 0 0 37.6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B33",
    d: "M235.7 71.2a21.3 21.3 0 1 1 0-42.6 21.3 21.3 0 0 1 0 42.6Zm0-37.7a16.3 16.3 0 1 0 0 32.7 16.3 16.3 0 0 0 0-32.7Zm89.1 9.1a21.3 21.3 0 1 1 0-42.6 21.3 21.3 0 0 1 0 42.6Zm0-37.6a16.3 16.3 0 1 0 0 32.6 16.3 16.3 0 0 0 0-32.6ZM146.6 42.6a21.3 21.3 0 1 1 0-42.6 21.3 21.3 0 0 1 0 42.6Zm0-37.6a16.4 16.4 0 1 0 0 32.7 16.4 16.4 0 0 0 0-32.7Zm89.1 400.1a2.5 2.5 0 0 1-2.5-2.4v-65.2a2.5 2.5 0 0 1 5 0v65.2a2.5 2.5 0 0 1-2.5 2.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACDBE6",
    d: "M249.8 434a18.8 18.8 0 1 0-28.2-25 18.8 18.8 0 0 0 28.2 25Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B33",
    d: "M146.6 433.7a2.5 2.5 0 0 1-2.5-2.5v-45.9a2.5 2.5 0 0 1 2.5-2.4h45.1v-45.5a2.5 2.5 0 0 1 5 0v48a2.5 2.5 0 0 1-2.5 2.4H149v43.4a2.5 2.5 0 0 1-2.5 2.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACDBE6",
    d: "M146.6 468.9a18.8 18.8 0 1 0 0-37.7 18.8 18.8 0 0 0 0 37.7Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B33",
    d: "M324.8 433.7a2.5 2.5 0 0 1-2.5-2.5v-43.4h-45.1a2.5 2.5 0 0 1-2.5-2.5v-47.9a2.5 2.5 0 0 1 5 0V383h45a2.5 2.5 0 0 1 2.5 2.4v46a2.5 2.5 0 0 1-2.4 2.4Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACDBE6",
    d: "M324.8 468.9a18.8 18.8 0 1 0 0-37.7 18.8 18.8 0 0 0 0 37.7Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B33",
    d: "M235.7 442.8a21.3 21.3 0 1 1 0-42.6 21.3 21.3 0 0 1 0 42.6Zm0-37.7a16.4 16.4 0 1 0 0 32.7 16.4 16.4 0 0 0 0-32.7Zm-89.1 66.3a21.3 21.3 0 1 1 0-42.6 21.3 21.3 0 0 1 0 42.6Zm0-37.7a16.3 16.3 0 1 0 0 32.8 16.3 16.3 0 0 0 0-32.8Zm178.2 37.7a21.3 21.3 0 1 1 0-42.6 21.3 21.3 0 0 1 0 42.6Zm0-37.7a16.3 16.3 0 1 0 0 32.8 16.3 16.3 0 0 0 0-32.8Zm77.9-195.5h-65.2a2.5 2.5 0 1 1 0-5h65.2a2.5 2.5 0 1 1 0 5Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACDBE6",
    d: "M440 239.1a18.8 18.8 0 1 0-37-7 18.8 18.8 0 0 0 37 7Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B33",
    d: "M431.2 327.2h-45.8a2.5 2.5 0 0 1-2.5-2.4v-45.1h-45.4a2.5 2.5 0 1 1 0-5h47.9a2.5 2.5 0 0 1 2.5 2.5v45h43.3a2.5 2.5 0 1 1 0 5Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACDBE6",
    d: "M450 343.6a18.8 18.8 0 1 0 0-37.7 18.8 18.8 0 0 0 0 37.7Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B33",
    d: "M385.4 196.7h-48a2.5 2.5 0 1 1 0-5H383v-45a2.5 2.5 0 0 1 2.5-2.5h45.8a2.5 2.5 0 0 1 0 5H388v45a2.5 2.5 0 0 1-2.5 2.5Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACDBE6",
    d: "M450 165.4a18.8 18.8 0 1 0 0-37.6 18.8 18.8 0 0 0 0 37.6Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B33",
    d: "M421.5 257a21.3 21.3 0 1 1 0-42.6 21.3 21.3 0 0 1 0 42.6Zm0-37.7a16.3 16.3 0 1 0 0 32.7 16.3 16.3 0 0 0 0-32.7ZM450 346a21.3 21.3 0 1 1 0-42.5 21.3 21.3 0 0 1 0 42.6Zm0-37.6a16.4 16.4 0 1 0 0 32.7 16.4 16.4 0 0 0 0-32.7Zm0-140.4a21.3 21.3 0 1 1 0-42.7 21.3 21.3 0 0 1 0 42.6Zm0-37.7a16.3 16.3 0 1 0 0 32.7 16.3 16.3 0 0 0 0-32.7ZM133.9 238.2H68.7a2.5 2.5 0 1 1 0-5h65.2a2.5 2.5 0 0 1 0 5Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACDBE6",
    d: "M49.9 254.5a18.8 18.8 0 1 0 0-37.6 18.8 18.8 0 0 0 0 37.6Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B33",
    d: "M133.9 196.7H86a2.5 2.5 0 0 1-2.3-1.5l-.2-1v-45.1H40.1a2.5 2.5 0 0 1 0-5h46a2.5 2.5 0 0 1 2.4 2.5v45h45.4a2.5 2.5 0 0 1 0 5Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACDBE6",
    d: "M21.3 165.4a18.8 18.8 0 1 0 0-37.6 18.8 18.8 0 0 0 0 37.6Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B33",
    d: "M86 327.2H40.1a2.5 2.5 0 1 1 0-5h43.4v-45a2.5 2.5 0 0 1 2.5-2.5h48a2.5 2.5 0 1 1 0 5H88.4v45a2.5 2.5 0 0 1-2.5 2.5Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACDBE6",
    d: "M21.3 343.6a18.8 18.8 0 1 0 0-37.7 18.8 18.8 0 0 0 0 37.7Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B33",
    d: "M49.9 257a21.3 21.3 0 1 1 0-42.6 21.3 21.3 0 0 1 0 42.6Zm0-37.7a16.4 16.4 0 1 0 0 32.7 16.4 16.4 0 0 0 0-32.7ZM21.3 168a21.3 21.3 0 1 1 0-42.7 21.3 21.3 0 0 1 0 42.6Zm0-37.7a16.3 16.3 0 1 0 0 32.7 16.3 16.3 0 0 0 0-32.7Zm0 215.7a21.3 21.3 0 1 1 0-42.5 21.3 21.3 0 0 1 0 42.6Zm0-37.6a16.4 16.4 0 1 0 0 32.7 16.4 16.4 0 0 0 0-32.7ZM337.5 340H133.9a2.5 2.5 0 0 1-2.5-2.5V133.9a2.5 2.5 0 0 1 2.5-2.5h203.6a2.5 2.5 0 0 1 2.4 2.5v203.6a2.5 2.5 0 0 1-2.4 2.4Zm-201.1-5H335V136.4H136.4V335Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA695F",
    d: "M327.6 143.8H143.8v183.8h183.8V143.8Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B33",
    d: "M327.6 330H143.8a2.5 2.5 0 0 1-2.5-2.4V143.8a2.5 2.5 0 0 1 2.5-2.5h183.8a2.5 2.5 0 0 1 2.4 2.5v183.8a2.5 2.5 0 0 1-2.4 2.4Zm-181.3-5H325V146.4H146.3V325Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACDBE6",
    d: "m234.6 262.8-41.8-24.1a2.2 2.2 0 0 1-.8-3l41.8-71.8a2.2 2.2 0 0 1 3.8 0l41.7 71.8a2.2 2.2 0 0 1-.1 2.4l-.7.6-41.7 24.1a2.2 2.2 0 0 1-2.2 0Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#88CBDB",
    d: "m279.3 235.7-41.7-71.8a2.1 2.1 0 0 0-2-1V263c.5 0 .8 0 1.2-.3l41.7-24.1a2.2 2.2 0 0 0 .8-3Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACDBE6",
    d: "m235.8 271.6 43.3-25h.4a.3.3 0 0 1 0 .5L236 308.5a.3.3 0 0 1-.2.1.3.3 0 0 1-.3-.1L191.8 247a.3.3 0 0 1 0-.4.3.3 0 0 1 .4-.1l43.3 25a.3.3 0 0 0 .3 0Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#88CBDB",
    d: "m279.1 246.6-43.3 25h-.1v37a.3.3 0 0 0 .3-.2l5.3-7.5 38.3-53.9v-.4a.3.3 0 0 0-.5 0Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#6FB6C7",
    d: "M235.1 263 193 238.8a1.1 1.1 0 0 1 0-2l42.3-18a1.1 1.1 0 0 1 1 0l42.2 18a1.1 1.1 0 0 1 0 2L236.3 263a1.1 1.1 0 0 1-1 0Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B33",
    d: "M235.7 265.5c-.8 0-1.6-.2-2.3-.6l-41.8-24.1a4.7 4.7 0 0 1-1.7-6.4l41.8-71.8a4.7 4.7 0 0 1 8 0l41.8 71.8a4.7 4.7 0 0 1-1.8 6.4L238 264.9c-.7.4-1.5.6-2.3.6Zm-41.4-28.9 41.4 24 41.3-24-41.3-71-41.4 71Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B33",
    d: "M235.7 311a2.8 2.8 0 0 1-2.3-1.1l-43.6-61.4a2.8 2.8 0 0 1 3.7-4l42.2 24.4 42.2-24.4a2.8 2.8 0 0 1 3.7 4L238 309.9a2.8 2.8 0 0 1-2.3 1.2Zm-36.2-57.3 36.2 50.9 36.1-51-34.7 20.2a2.8 2.8 0 0 1-2.8 0l-34.8-20.1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.9aeea3fd2e3fae0007bb1774af997fc4.svg";
export { ForwardRef as ReactComponent };